import { render, staticRenderFns } from "./CoursewareTimelineBlock.vue?vue&type=template&id=2d3ec900&scoped=true&"
import script from "./CoursewareTimelineBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareTimelineBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTimelineBlock.vue?vue&type=style&index=0&id=2d3ec900&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ec900",
  null
  
)

export default component.exports